import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { AlertTriangle, CreditCard } from "lucide-react";

export default function TrialBanner({ access }) {
  const startCheckout = async () => {
    try {
      const { data } = await api.post("/billing/checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error("Could not start checkout. Try again.");
    }
  };
  const openPortal = async () => {
    try {
      const { data } = await api.post("/billing/portal", { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      toast.error("Could not open billing portal.");
    }
  };

  const isTrial = access.state === "trialing";
  const bg = isTrial ? "bg-blue-50 border-blue-200 text-blue-900" : "bg-amber-50 border-amber-200 text-amber-900";
  const label = access.state === "past_due" ? "Update card" : "Subscribe now";
  const action = access.state === "past_due" ? openPortal : startCheckout;

  return (
    <div className={`border-b ${bg}`} data-testid="trial-banner">
      <div className="max-w-6xl mx-auto px-4 md:px-8 py-2.5 flex items-center gap-3 flex-wrap">
        <AlertTriangle className="h-4 w-4 flex-none" />
        <span className="text-sm font-medium flex-1" data-testid="trial-banner-text">{access.banner}</span>
        {access.state !== "trialing" || access.trial_days_left <= 3 ? (
          <button data-testid="trial-banner-cta" onClick={action}
            className="text-sm font-semibold px-3 py-1.5 rounded-full bg-primary text-white hover:bg-primary/90 transition-colors">
            <CreditCard className="inline h-3.5 w-3.5 mr-1" />{label}
          </button>
        ) : null}
      </div>
    </div>
  );
}
